/* eslint-disable max-lines */
import type { TranslationDataObj } from './type';

export const data: TranslationDataObj = {
  'app.settings.sidebar': {
    userSettings: {
      en: 'User settings',
      fr: "Paramètres de l'utilisateur",
    },
    organizations: {
      en: 'Organizations',
      fr: 'Organisations',
    },
    owned: {
      en: 'Owned',
      fr: 'Propriétaire',
    },
    user: {
      en: 'User',
      fr: 'Utilisateur',
    },
    you: {
      en: 'You',
      fr: 'Vous',
    },
    profileSettings: {
      en: 'Profile settings',
      fr: 'Paramètres du profil',
    },
    notifications: {
      en: 'Notifications',
      fr: 'Notifications',
    },
  },
  'app.settings.user': {
    title: {
      en: 'User settings',
      fr: "Paramètres de l'utilisateur",
    },
    firstName: {
      en: 'First name',
      fr: 'Prénom',
    },
    firstNamePlaceholder: {
      en: 'Enter your first name',
      fr: 'Entrez votre prénom',
    },
    lastName: {
      en: 'Last name',
      fr: 'Nom',
    },
    lastNamePlaceholder: {
      en: 'Enter your last name',
      fr: 'Entrez votre nom',
    },
    email: {
      en: 'Email',
      fr: 'Email',
    },
    emailTooltip: {
      en: 'Email cannot be changed',
      fr: 'Cet email sera utilisé pour vous envoyer des notifications',
    },
    emailPlaceholder: {
      en: 'Enter your email',
      fr: 'Entrez votre email',
    },
    savingUser: {
      en: 'Saving user...',
      fr: "Enregistrement de l'utilisateur...",
    },
    userUpdated: {
      en: 'User updated',
      fr: 'Utilisateur mis à jour',
    },
    errorSavingUser: {
      en: 'Error saving user',
      fr: "Erreur lors de l'enregistrement de l'utilisateur",
    },
    deleteAccount: {
      en: 'Delete account',
      fr: 'Supprimer le compte',
    },
    areYouSure: {
      en: 'Are you sure you want to delete your account?',
      fr: 'Êtes-vous sûr de vouloir supprimer votre compte ?',
    },
    step1UserDeleteDescription: {
      en: 'Deleting your account will permanently revoke your access to all the organizations you are part of. This action cannot be undone. Are you sure you want to proceed?',
      fr: 'Supprimer votre compte entraînera la suppression de votre accès à toutes les organisations auxquelles vous êtes lié. Cette action est irréversible. Êtes-vous sûr de vouloir continuer ?',
    },
    step2UserDeleteDescription: {
      en: 'Before you go, could you let us know why you are deleting your account? It will help us improve.',
      fr: 'Avant de supprimer votre compte, pouvez-vous nous indiquer le motif de votre suppression ? Cela nous aidera à améliorer notre service.',
    },
    step1OwnerDeleteDescription: {
      en: 'Before deleting your account, you must delete or transfer ownership of your organizations.',
      fr: 'Avant de supprimer votre compte, vous devez supprimer ou transférer la propriété de vos organisations.',
    },
    removeAllContent: {
      en: 'Deleting your account will permanently remove all content associated with it.',
      fr: 'Supprimer votre compte entraînera la suppression de tout le contenu associé à lui.',
    },
    removeAllContentDescription: {
      en: 'You wont be able to access your content on the platform anymore. Are you sure you want to proceed?',
      fr: 'Vous ne pourrez plus accéder à votre contenu sur la plateforme. Êtes-vous sûr de vouloir continuer ?',
    },
    removeSubscription: {
      en: 'Deleting your account will cancel your subscription immediately.',
      fr: "Supprimer votre compte entraînera l'annulation de votre abonnement immédiatement.",
    },
    moreDetailOnDeleteDescription: {
      en: 'Before you go, could you let us know why you are deleting your account? It will help us improve.',
      fr: 'Avant de supprimer votre compte, pouvez-vous nous indiquer le motif de votre suppression ? Cela nous aidera à améliorer notre service.',
    },
    cancelSubscription: {
      en: 'Deleting your account will cancel your subscription immediately.',
      fr: "Supprimer vos organisations entraînera l'annulation de votre abonnement immédiatement.",
    },
    cancelSubscriptionDescription: {
      en: 'You will lose any remaining paid features. Are you sure you want to proceed?',
      fr: 'Vous perdrez tous les avantages payés. Êtes-vous sûr de vouloir continuer ?',
    },
    removeContent: {
      en: 'Remove content',
      fr: 'Supprimer le contenu',
    },
    unsubscribe: {
      en: 'Unsubscribe',
      fr: 'Désabonner',
    },
    deleteAccountLabel: {
      en: 'Add reason for deleting your account',
      fr: 'Ajouter le motif de suppression de votre compte',
    },
    labelConfirmTextDeleteAccount: {
      en: 'Write DELETE ACCOUNT below to confirm',
      fr: 'Écrivez SUPPRIMER LE COMPTE ci-dessous pour confirmer',
    },
    confirmTextDeleteAccount: {
      en: 'DELETE ACCOUNT',
      fr: 'SUPPRIMER LE COMPTE',
    },
    deleteAccountConfirmation: {
      en: 'Delete my organizations and account',
      fr: 'Supprimer mes organisations et mon compte',
    },
    yesDeleteIt: {
      en: 'Yes, delete it',
      fr: 'Oui, supprimer',
    },
    cantDeleteDescription: {
      en: 'You can’t delete this account until you delete or transfer ownership of your organizations.',
      fr: 'Vous ne pouvez pas supprimer ce compte tant que vous n’avez pas supprimé ou transféré la propriété de vos organisations.',
    },
    review: {
      en: 'Review',
      fr: 'Vérifier',
    },
    unableToArchiveOwnerWithActiveSubscription: {
      en: 'You can’t delete this account until you cancel your active subscription.',
      fr: 'Vous ne pouvez pas supprimer ce compte tant que vous n’avez pas annulé votre abonnement actif.',
    },
    unableToArchiveOwnerWithMultipleUsers: {
      en: 'You can’t delete this account until you delete or transfer ownership of your organizations.',
      fr: 'Vous ne pouvez pas supprimer ce compte tant que vous n’avez pas supprimé ou transféré la propriété de vos organisations.',
    },
  },
  'app.settings.notifications': {
    savingNotifications: {
      en: 'Saving notifications...',
      fr: 'Enregistrement des notifications...',
    },
    notificationsUpdated: {
      en: 'Notifications updated',
      fr: 'Notifications mises à jour',
    },
    title: {
      en: 'Notifications',
      fr: 'Notifications',
    },
    description: {
      en: 'Manage your notification preferences and stay updated with Blym',
      fr: 'Gérez vos préférences de notification et restez informé de Blym',
    },
    emailNotifications: {
      en: 'Email notifications',
      fr: 'Notifications par email',
    },
    inAppNotifications: {
      en: 'In-app notifications',
      fr: "Notifications dans l'application",
    },
    contentReadyTitle: {
      en: 'Content ready',
      fr: 'Contenu prêt',
    },
    contentReadyDescription: {
      en: 'Receive an email when your content or product page generation is complete',
      fr: 'Recevoir des notifications lorsque votre contenu ou page produit est prêt',
    },
    whatsNewTitle: {
      en: "What's new on Blym",
      fr: 'Nouveautés sur Blym',
    },
    whatsNewDescription: {
      en: 'Stay informed about new features, improvements, and updates to Blym',
      fr: 'Restez informé des nouvelles fonctionnalités, améliorations et mises à jour de Blym',
    },
    errorSavingNotifications: {
      en: 'Error saving notifications',
      fr: "Erreur lors de l'enregistrement des notifications",
    },
  },
  'app.settings.organization.users': {
    users: {
      en: 'Users',
      fr: 'Utilisateurs',
    },
    addUser: {
      en: 'Add user',
      fr: 'Ajouter un utilisateur',
    },
    addUserToOrganization: {
      en: 'Add user to organization',
      fr: "Ajouter un utilisateur à l'organisation",
    },
    inviteInformation: {
      en: 'We will send an invite to that email so they can join you in your organization.',
      fr: "Nous vous envoyerons une invitation à cet email pour qu'ils puissent rejoindre votre organisation.",
    },
    updateYourPlan: {
      en: 'Update to business to add more members',
      fr: "Mettez à niveau vers le plan business pour ajouter plus d'utilisateurs",
    },
    updateToBusinessDescription: {
      en: 'With business you will get: \n - 3 more members \n - 10 extra credits per month ',
      fr: 'Avec le plan business, vous obtiendrez: \n - 3 utilisateurs supplémentaires \n - 10 crédits supplémentaires par mois',
    },
    invitedUsers: {
      en: 'Invited users',
      fr: 'Utilisateurs invités',
    },
    makeOwnerOfTheOrganization: {
      en: 'Make owner of the organization',
      fr: 'Ajouter en tant que propriétaire',
    },
    deleteFromOrganization: {
      en: 'Delete from organization',
      fr: "Supprimer de l'organisation",
    },
    inviteUser: {
      en: 'Add user',
      fr: 'Inviter un utilisateur',
    },
    newUserEmail: {
      en: 'New user email',
      fr: 'Email du nouvel utilisateur',
    },
    emailInfo: {
      en: 'We will send an invite to that email so they can join you in your organization.',
      fr: "Nous vous envoyerons une invitation à cet email pour qu'ils puissent rejoindre votre organisation.",
    },
    sendInvite: {
      en: 'Send invite',
      fr: "Envoyer l'invitation",
    },
    titleInvitedUser: {
      en: 'Invitation sent',
      fr: 'Invitation envoyée',
    },
    deleteUser: {
      en: 'Delete user',
      fr: "Supprimer l'utilisateur",
    },
    deleteUserDescription: {
      en: 'This member will lose full access to the organization and the content in it.',
      fr: "Cet utilisateur perdra accès complet à l'organisation et au contenu qu'il a créé.",
    },
    yesDeleteUser: {
      en: 'Yes, delete user',
      fr: "Oui, supprimer l'utilisateur",
    },
    toastTitleDeletedUser: {
      en: 'User deleted from organization',
      fr: "Utilisateur supprimé de l'organisation",
    },
    deleteUserFailed: {
      en: 'Delete user failed, please try again later',
      fr: "La suppression de l'utilisateur a échoué, veuillez réessayer plus tard",
    },
    inviteFailed: {
      en: 'Invite failed, please try again later',
      fr: "L'invitation a échoué, veuillez réessayer plus tard",
    },
    inviteMemberExistsFailed: {
      en: 'This user is already a member of this organization',
      fr: 'Cet utilisateur est déjà membre de cette organisation',
    },
    transferOwnershipFailed: {
      en: 'Transfer ownership failed, please try again later',
      fr: 'La transfert de propriété a échoué, veuillez réessayer plus tard',
    },
    toastTitleTransferredOwnership: {
      en: 'Ownership transferred',
      fr: 'Propriété transférée',
    },
    transferOwnership: {
      en: 'Transfer ownership',
      fr: 'Transférer la propriété',
    },
    transferOwnershipDescription: {
      en: 'You’re about to transfer all control and ownership of this organization. This action cannot be undone.',
      fr: 'Vous êtes sur le point de transférer tous les contrôles et la propriété de cette organisation. Cette action ne peut pas être annulée.',
    },
    yesTransferOwnership: {
      en: 'Yes, transfer ownership',
      fr: 'Oui, transférer la propriété',
    },
    invited: {
      en: 'Invited',
      fr: 'Invité',
    },
    cancelInvitation: {
      en: 'Cancel invitation',
      fr: "Annuler l'invitation",
    },
    resendInvitation: {
      en: 'Resend invitation',
      fr: "Renvoyer l'invitation",
    },
    toastTitleRevokedInvite: {
      en: 'Invite revoked',
      fr: 'Invitation révoquée',
    },
    revokeInviteFailed: {
      en: 'Revoke invite failed, please try again later',
      fr: "La révocation de l'invitation a échoué, veuillez réessayer plus tard",
    },
    toastTitleResendedInvite: {
      en: 'Invite resent',
      fr: 'Invitation renvoyée',
    },
    resendInviteFailed: {
      en: 'Resend invite failed, please try again later',
      fr: "Le renvoi de l'invitation a échoué, veuillez réessayer plus tard",
    },
  },
  'app.settings.organization.billing': {
    unsubscribed: {
      en: 'Unsubscribed',
      fr: 'Désabonné',
    },
    billing: {
      en: 'Billing',
      fr: 'Facturation',
    },
    plan: {
      en: 'Plan',
      fr: 'Abonnement',
    },
    plans: {
      en: 'Plans',
      fr: 'Abonnements',
    },
    perMonth: {
      en: '/per month',
      fr: '/par mois',
    },
    perYear: {
      en: '/per year',
      fr: '/par an',
    },
    billedMonthly: {
      en: 'Billed monthly',
      fr: 'Facturé mensuellement',
    },
    billedYearly: {
      en: 'Billed yearly',
      fr: 'Facturé annuellement',
    },
    extraCreditsCount: {
      en: '{{ count }} credits',
      fr: '{{ count }} crédits',
    },
    orgUserCount: {
      en: '{{ count }} users',
      fr: '{{ count }} utilisateurs',
    },
    freePlan: {
      en: 'Free Plan',
      fr: 'Abonnement Gratuit',
    },
    upgrade: {
      en: 'Upgrade',
      fr: 'Mettre à niveau',
    },
    monthly: {
      en: 'Monthly',
      fr: 'Mensuel',
    },
    yearly: {
      en: 'Yearly',
      fr: 'Annuel',
    },
    enterprise: {
      en: 'Enterprise plan',
      fr: 'Forfait Entreprise',
    },
    contactUs: {
      en: 'Contact us',
      fr: 'Contactez-nous',
    },
    contactUsDescription: {
      en: 'We will provide you with a tailored solution.',
      fr: 'Nous vous proposerons une solution adaptée à vos besoins.',
    },
    renewDate: {
      en: 'Renew {{date}}',
      fr: 'Renouveler {{date}}',
    },
    currentPlan: {
      en: 'Current plan',
      fr: 'Plan actuel',
    },
    upgradeTo: {
      en: 'Upgrade to {{plan}}',
      fr: 'Passer sur {{plan}}',
    },
    upgradeToYearly: {
      en: 'Upgrade to yearly',
      fr: 'Payer annuellement',
    },
    downgradeToMonthly: {
      en: 'Downgrade to monthly',
      fr: 'Payer mensuellement',
    },
    switchToYearly: {
      en: 'Switch to yearly',
      fr: "Passer à l'annuel",
    },
    switchToMonthly: {
      en: 'Switch to monthly',
      fr: 'Passer au mensuel',
    },
    free: {
      en: 'Free',
      fr: 'Gratuit',
    },
    downgradeTo: {
      en: 'Downgrade to {{plan}}',
      fr: 'Passer sur {{plan}}',
    },
    downgradeTitleCard: {
      en: 'You have downgraded to {{ plan }} plan.',
      fr: 'Vous êtes passé vers le plan {{ plan }}',
    },
    looseAccessFeatures: {
      en: 'You will loose access to {{ plan }} features on {{ date }}',
      fr: 'Vous perdrez accès aux fonctionnalités {{ plan }} le {{ date }}',
    },
    cancelDowngradeInfo: {
      en: 'Cancel your downgrade to update your plan.',
      fr: 'Annuler le changement pour mettre à jour votre abonnement.',
    },
    cancelDowngradeButton: {
      en: 'Cancel downgrade',
      fr: 'Annuler le changement',
    },
    cancelDowngradeError: {
      en: 'Error canceling downgrade',
      fr: "Erreur lors de l'annulation du changement",
    },
    cancelDowngradeErrorDescription: {
      en: 'Please try again or contact support',
      fr: 'Veuillez réessayer ou contacter le support',
    },
    subscriptionUpdatedYearly: {
      en: 'Your subscription has been updated!',
      fr: 'Votre abonnement a été mis à jour!',
    },
    subscriptionUpdatedMonthly: {
      en: 'Your subscription has been updated!',
      fr: 'Votre abonnement a été mis à jour!',
    },
    subscriptionUpdated: {
      en: 'Subscription upgraded to {{plan}}!',
      fr: 'Abonnement mis à niveau vers {{plan}}!',
    },
    subscriptionUpdatedYearlyDescription: {
      en: 'You’ve switched to a yearly plan and saved {{amount}} great choice!',
      fr: 'Vous avez économisé {{amount}} en passant à la facturation annuelle.',
    },
    subscriptionUpdatedMonthlyDescription: {
      en: 'You’re now on a monthly plan. Monthly billing will start on: {{date}}.',
      fr: 'Vous êtes maintenant sur un abonnement mensuel. La facturation mensuelle commencera le: {{date}}.',
    },
    altImagePaperPlane: {
      en: 'Paper plane',
      fr: 'Avion de papier',
    },
    altImageCalendar: {
      en: 'Calendar',
      fr: 'Calendrier',
    },
    goToDashboard: {
      en: 'Go to dashboard',
      fr: 'Aller au tableau de bord',
    },
    switchToMonthlySubscription: {
      en: 'Switch to Monthly Subscription',
      fr: "Passer à l'abonnement mensuel",
    },
    switchToMonthlySubscriptionDescription: {
      en: 'If you switch to a monthly subscription, your costs will increase by 20%. Are you sure you want to proceed?',
      fr: 'Si vous passez à un abonnement mensuel, vos coûts augmenteront de 20%. Êtes-vous sûr de vouloir continuer ?',
    },
    changeMonthlySubscription: {
      en: 'Switch to monthly',
      fr: 'Passer à la facturation mensuelle',
    },
    keepSaving: {
      en: 'Keep saving',
      fr: 'Continuer à économiser',
    },
    bestChoice: {
      en: 'Best value',
      fr: 'Meilleure valeur',
    },
    mostPopular: {
      en: 'Most popular',
      fr: 'Plus populaire',
    },
    subscriptionUpdatedDescription: {
      en: 'Your account has been successfully updated to the {{ plan }} plan.',
      fr: 'Votre compte a été mis à jour avec succès vers le plan {{ plan }}.',
    },
    keepCurrentPlan: {
      en: 'Keep plan',
      fr: "Conserver l'abonnement",
    },
    goUsersPage: {
      en: 'Go to users page',
      fr: 'Aller à la page des utilisateurs',
    },
    downgradeSubscription: {
      en: 'Downgrade subscription',
      fr: "Changement d'offre",
    },
    downgradeSubscriptionDescription: {
      en: 'To downgrade your subscriptrion you first need to delete two members from your organization.',
      fr: 'Si vous changez votre abonnement, vous perdrez tous vos crédits et vous ne pourrez pas créer de nouveau contenu.',
    },
    downgradeSubscriptionDescriptionWithoutMembers: {
      en: 'By switching to the Pro plan:\n - 2 fewer seats for your team members.\n - 30% higher cost per content.\n - 15 fewer credits per month.',
      fr: "En passant sur l'abonnement pro :\n - 2 utilisateurs en moins.\n - 30% plus cher par contenu.\n - 15 crédits par mois de moins.",
    },
    downgrade: {
      en: 'Downgrade',
      fr: "Changer d'abonnement",
    },
    cancelPlan: {
      en: 'Cancel plan',
      fr: "Annuler l'abonnement",
    },
    cancelFlowTitle0: {
      en: 'Are you sure you want to cancel?',
      fr: 'Êtes-vous sûr de vouloir annuler ?',
    },
    cancelFlowTitle1: {
      en: 'Cancelation reason',
      fr: "Motif de l'annulation",
    },
    cancelFlowTitle2: {
      en: 'How About a 20% Discount?',
      fr: 'Un rabais de 20% ?',
    },
    cancelFlowTitle3: {
      en: 'We’re Sorry to See You Go!',
      fr: 'Nous sommes désolés de vous voir partir !',
    },
    cancelFlowDescription0: {
      en: 'Canceling your subscription means:\n - All organization users will lose access.\n - Any remaining credits will be forfeited.\n - You won’t be able to update your content anymore.',
      fr: "Annuler votre abonnement signifie :\n - Tous les utilisateurs de l'organisation perdront accès.\n - Tous les crédits restants seront perdus.\n - Vous ne pourrez plus mettre à jour votre contenu.",
    },
    cancelFlowDescription1: {
      en: 'Before you go, could you let us know why you are cancelling? It will help us improve.',
      fr: 'Avant de partir, pouvez-vous nous indiquer le motif de votre annulation ? Cela nous aidera à améliorer notre service.',
    },
    cancelFlowDescription2: {
      en: 'Enjoy a 20% discount on your subscription for the next six months. Don’t miss out on this limited-time offer!',
      fr: 'Profitez d’un rabais de 20% sur votre abonnement pour les six prochains mois. Ne manquez pas cette offre limitée !',
    },
    cancelFlowDescription3: {
      en: 'You can reactivate your subscription anytime and pick up right where you left off. Your remaining credits will still be available for use.',
      fr: 'Vous pouvez réactiver votre abonnement à tout moment et reprendre exactement où vous l’avez laissé. Vos crédits restants seront toujours disponibles pour utilisation.',
    },
    cancelSubscription: {
      en: 'Cancel subscription',
      fr: "Annuler l'abonnement",
    },
    cancelFlowLeftButtonText1: {
      en: 'Send',
      fr: 'Envoyer',
    },
    cancelFlowLeftButtonText2: {
      en: 'No, I still want to cancel',
      fr: 'Non, je veux quand même annuler',
    },
    cancelFlowRightButtonText0: {
      en: 'Keep subscription',
      fr: "Annuler l'abonnement",
    },
    cancelFlowRightButtonText2: {
      en: 'Yes, get a 20% off',
      fr: 'Oui, obtenir un rabais de 20%',
    },
    reactivateSubscription: {
      en: 'Reactivate subscription',
      fr: "Réactiver l'abonnement",
    },
    subscriptionWasCanceled: {
      en: 'Your subscription has been cancelled.',
      fr: 'Votre abonnement a été annulé.',
    },
    reSubscribe: {
      en: 'Resubscribe to regain access to all features.',
      fr: 'Re-souscrire pour retrouver accès à toutes les fonctionnalités.',
    },
    reactivateSubCardTitle: {
      en: 'You cancelled your subscription.',
      fr: 'Vous avez annulé votre abonnement.',
    },
    reactivateSubCardDescription: {
      en: 'You will loose access to Blym on {{date}}',
      fr: 'Vous perdrez accès à Blym le {{date}}',
    },
    cancelReasonLabel: {
      en: 'Add a reason for cancelation*',
      fr: "Ajouter un motif de l'annulation*",
    },
    uncancelError: {
      en: 'Error uncancel subscription',
      fr: "Erreur lors de la réactivation de l'abonnement",
    },
    uncancelErrorDescription: {
      en: 'Please try again or contact support',
      fr: 'Veuillez réessayer ou contacter le support',
    },
    discountCode: {
      en: 'I have a discount code',
      fr: "J'ai un code de réduction",
    },
    discountPercent: {
      en: '{{ percent }}% discount',
      fr: '{{ percent }}% de réduction',
    },
    applyDiscount: {
      en: 'Apply discount',
      fr: 'Appliquer le code de réduction',
    },
    enterDiscountCode: {
      en: 'Enter your discount code',
      fr: 'Entrez votre code de réduction',
    },
    apply: {
      en: 'Apply',
      fr: 'Appliquer',
    },
    creditUsage: {
      en: 'Credit usage',
      fr: 'Utilisation des crédits',
    },
    creditUsageDescription: {
      en: 'Track your subscription usage and limits',
      fr: 'Suivez l’utilisation et les limites de votre abonnement',
    },
    bookACall: {
      en: 'Book a call',
      fr: 'Réserver un appel',
    },
    enterpriseSubscription: {
      en: 'Enterprise subscription',
      fr: 'Abonnement pour entreprises',
    },
    reachOutToAddon: {
      en: 'Reach out to add content or collections',
      fr: 'Contactez-nous pour ajouter du contenu ou des collections',
    },
    billedAnnually: {
      en: 'Billed annually at {{ price }}',
      fr: 'Facturé annuellement à {{ price }}',
    },
    renewsOn: {
      en: 'Renews on {{ date }}',
      fr: 'Renouvellement le {{ date }}',
    },
    blogPosts: {
      en: 'Content',
      fr: 'Contenu',
    },
    collections: {
      en: 'Collections',
      fr: 'Collections',
    },
    products: {
      en: 'Products',
      fr: 'Produits',
    },
    productsPages: {
      en: 'Product pages',
      fr: 'Pages produit',
    },
    annualCreditUsage: {
      en: '{{percentage}}% of your annual limit is used',
      fr: '{{percentage}}% de votre limite annuelle est utilisé',
    },
    addOns: {
      en: 'Add-ons',
      fr: 'Modules complémentaires',
    },
    reachedLimitCycle: {
      en: 'You’ve reached your product page limit for this billing cycle',
      fr: 'Vous avez atteint votre limite de pages produit pour ce cycle de facturation.',
    },

    keepPlan: {
      en: 'Keep plan',
      fr: 'Garder le plan',
    },
    cancelPlanDescriptionModal: {
      en: "Are you sure you want to cancel your plan?<br/>You'll keep access until <strong>{{date}}</strong>, the end of your current billing period.",
      fr: "Êtes-vous sûr de vouloir annuler votre plan ?<br/>Vous garderez accès jusqu'au <strong>{{date}}</strong>, la fin de votre période de facturation actuelle.",
    },
    cancelPlanStep2Description: {
      en: 'Before you go, could you let us know why you are cancelling? It will help us improve.',
      fr: 'Avant de partir, pourriez-vous nous dire pourquoi vous annulez? Cela nous aidera à nous améliorer.',
    },
    confirmTextCancelPlan: {
      en: 'CANCEL PLAN',
      fr: 'ANNULER LE PLAN',
    },
    labelConfirmTextCancelPlan: {
      en: 'Write CANCEL PLAN below to confirm',
      fr: 'Écrivez ANNULER LE PLAN ci-dessous pour confirmer',
    },
    cancelPlanLabel: {
      en: 'Add reason for cancelling',
      fr: "Ajoutez la raison de l'annulation",
    },
    cancelPlanConfirmation: {
      en: 'Cancel my organization plan',
      fr: 'Annuler le forfait de mon organisation',
    },
  },
  'app.settings.organization.header': {
    members: {
      en: 'Members',
      fr: 'Utilisateurs',
    },
    brands: {
      en: 'Brands',
      fr: 'Marques',
    },
    billing: {
      en: 'Billing',
      fr: 'Facturation',
    },
    plan: {
      en: 'Plan',
      fr: 'Abonnement',
    },
    integrations: {
      en: 'Integrations',
      fr: 'Intégrations',
    },
    credits: {
      en: 'Credits',
      fr: 'Crédits',
    },
    editOrgName: {
      en: 'Edit org. name',
      fr: "Modifier le nom de l'organisation",
    },
    editOrgNameTitle: {
      en: 'Edit organization name',
      fr: "Modifier le nom de l'organisation",
    },
    deleteOrg: {
      en: 'Delete org.',
      fr: "Supprimer l'organisation",
    },
    leaveOrganization: {
      en: 'Leave org.',
      fr: "Quitter l'organisation",
    },
    leaveOrg: {
      en: 'Leave org.',
      fr: "Quitter l'organisation",
    },
    orgChangeSuccess: {
      en: 'Changes saved',
      fr: 'Changements enregistrés',
    },
    orgChangeError: {
      en: 'Error saving changes',
      fr: "Erreur lors de l'enregistrement des modifications",
    },
    deleteOrgModalTitleStep1: {
      en: 'Deleting your organization will permanently remove users, content and will cancel your subscription.',
      fr: "La suppression de votre organisation entraînera la suppression des utilisateurs, des contenus et l'annulation de votre abonnement.",
    },
    deleteOrgModalTitleStep2: {
      en: 'Delete organization',
      fr: "Supprimer l'organisation",
    },
    deleteOrgModalDescriptionStep1: {
      en: 'Are you sure This action cannot be undone. Are you sure you want to proceed?',
      fr: 'Êtes-vous sûr de vouloir procéder ? Cette action est irréversible.',
    },
    deleteOrgModalDescriptionStep2: {
      en: 'Before you go, could you let us know why you are deleting your organization? It will help us improve.',
      fr: "Avant de partir, pouvez-vous nous indiquer le motif de votre suppression de l'organisation ? Cela nous aidera à améliorer notre service.",
    },
    deleteOrgModalLeftButtonText1: {
      en: 'Yes I want to delete',
      fr: 'Oui, je veux supprimer',
    },
    deleteOrgModalRightButtonText1: {
      en: 'Keep my access',
      fr: 'Conserver mon accès',
    },
    deleteOrgModalLeftButtonText2: {
      en: 'Send reason',
      fr: 'Envoyer',
    },
    writeOrgNameLabel: {
      en: 'Write {{ orgName }} below to confirm',
      fr: 'Écrivez {{ orgName }} pour confirmer',
    },

    deleteOrgModalButtonText3: {
      en: 'Unsubscribe and delete organization',
      fr: "Annuler et supprimer l'organisation",
    },
    deleteOrgReasonLabel: {
      en: 'Add a reason for cancelation*',
      fr: "Ajouter un motif de l'annulation*",
    },
    unsubscribeAndDeleteOrg: {
      en: 'Unsubscribe and delete organization',
      fr: "Annuler et supprimer l'organisation",
    },
    errorSendingForm: {
      en: 'Error sending form',
      fr: "Erreur lors de l'envoi du formulaire",
    },
    errorDeleteOrg: {
      en: 'Error deleting organization',
      fr: "Erreur lors de la suppression de l'organisation",
    },
    errorDeleteOrgDescription: {
      en: 'Please try again or contact support',
      fr: 'Veuillez réessayer ou contacter le support',
    },
    leaveOrgModalTitle: {
      en: 'Leave organization',
      fr: "Quitter l'organisation",
    },
    leaveOrgModalDescription: {
      en: 'Are you sure This action cannot be undone. If you leave the organization you will loose access to it’s content. Are you sure you want to proceed?',
      fr: "Êtes-vous sûr de vouloir quitter l'organisation ? Cette action est irréversible. Si vous quittez l'organisation, vous perdrez accès à son contenu. Êtes-vous sûr de vouloir continuer ?  ",
    },
    leaveOrgModalLeftButtonText: {
      en: 'Yes, leave organization',
      fr: "Oui, quitter l'organisation",
    },
    yesIwantToLeave: {
      en: 'Yes, I want to leave',
      fr: 'Oui, je veux quitter',
    },
    keepMyAccess: {
      en: 'Keep my access',
      fr: 'Conserver mon accès',
    },
  },
  'app.settings.organization.brands': {
    brands: {
      en: 'Brands',
      fr: 'Marques',
    },
    createBrand: {
      en: 'New brand',
      fr: 'Nouvelle marque',
    },
    pieceOfContent: {
      en: '{{contents}} pieces of contents',
      fr: '{{contents}} articles',
    },
    editAttributes: {
      en: 'Edit attributes',
      fr: 'Modifier les attributs',
    },
    createContent: {
      en: 'Create content',
      fr: 'Créer un contenu',
    },
    yesDeleteBrand: {
      en: 'Yes, delete brand',
      fr: 'Oui, supprimer la marque',
    },
    deleteBrand: {
      en: 'Delete brand',
      fr: 'Supprimer la marque',
    },
    deleteBrandTitle: {
      en: 'Are you sure you want to delete the brand and all associated content?',
      fr: 'Êtes-vous sûr de vouloir supprimer la marque et tous les contenus associés ?',
    },
    deleteBrandDescription: {
      en: 'Deleting your brand will permanently remove all associated content and context. This action cannot be undone.',
      fr: 'La suppression de cette marque entraînera également la suppression de tous ses contenus et contextes associés. Cette action ne peut pas être annulée.',
    },
    keepBrand: {
      en: 'Keep brand',
      fr: 'Conserver la marque',
    },
    deleteBrandAndContent: {
      en: 'Delete the brand and its content',
      fr: 'Supprimer la marque et ses contenus',
    },
    writeBrandNameToConfirm: {
      en: 'Write {{brandName}} below to confirm',
      fr: 'Écrivez {{brandName}} pour confirmer',
    },
    errorBrandName: {
      en: 'Brand name is incorrect',
      fr: 'Le nom de la marque est incorrect',
    },
    newBrand: {
      en: 'New brand',
      fr: 'Nouvelle marque',
    },
    brandNameLabel: {
      en: 'Brand name',
      fr: 'Nom de la marque',
    },
    brandNamePlaceholder: {
      en: 'Enter the brand name',
      fr: 'Entrez le nom de la marque',
    },
    brandWebsiteLabel: {
      en: 'Brand website (optional)',
      fr: 'Site web de la marque (optionnel)',
    },
    brandWebsitePlaceholder: {
      en: 'https://www.example.com',
      fr: 'https://www.example.com',
    },
    cannotCreateBrand: {
      en: 'Cannot create brand',
      fr: 'Impossible de créer la marque',
    },
    brandCreated: {
      en: 'Brand created',
      fr: 'Marque créée',
    },
    brandDeleted: {
      en: 'Brand deleted',
      fr: 'Marque supprimée',
    },
    brandDeletedError: {
      en: 'Brand deleted error',
      fr: 'Erreur lors de la suppression de la marque',
    },
  },
  'app.settings.organization.credits': {
    freePlanAlertTitle: {
      en: 'You are on a free plan',
      fr: 'Vous êtes sur un abonnement gratuit',
    },
    freePlanAlertDescription: {
      en: 'Upgrade to a paid plan to buy credits.',
      fr: 'Mettez à niveau vers un forfait payant pour acheter des crédits',
    },
    subscriptionWasCanceled: {
      en: 'Your subscription has been cancelled.',
      fr: 'Votre abonnement a été annulé.',
    },
    reSubscribeToBuyCredits: {
      en: 'Subscribe to a plan to regain access to your credits.',
      fr: 'Souscrivez à un plan pour retrouver accès à vos crédits.',
    },
    yourCredits: {
      en: 'Your credits',
      fr: 'Vos crédits',
    },
    balance: {
      en: 'Balance',
      fr: 'Solde',
    },
    buyCredits: {
      en: 'Buy credits',
      fr: 'Acheter des crédits',
    },
    billing: {
      en: 'Billing',
      fr: 'Facturation',
    },
    credit: {
      en: 'Credit',
      fr: 'Crédit',
    },
    credits: {
      en: 'Credits',
      fr: 'Crédits',
    },
    pricePerCredit: {
      en: '{{ currency }}{{ price }} per credit',
      fr: '{{ currency }}{{ price }} par crédit',
    },
    packOf: {
      en: 'Pack of {{ pack }} ',
      fr: 'Pack de {{ pack }}',
    },
    buyCreditsNumber: {
      en: 'Buy {{ count }} credits',
      fr: 'Acheter {{ count }} crédits',
    },
    buySingleCredits: {
      en: 'Buy 1 credit',
      fr: 'Acheter 1 crédit',
    },
    buyCreditsButton: {
      en: 'Buy and save {{ discount }}%',
      fr: 'Offre - {{ discount }}%',
    },
    discount: {
      en: 'Discount',
      fr: 'Remise',
    },
    perCredit: {
      en: 'per credit',
      fr: 'par crédit',
    },
    totalPrice: {
      en: 'Total: {{ currency }}{{ price }}',
      fr: 'Total: {{ currency }}{{ price }}',
    },
    singlePerCredits: {
      en: '({{ currency }}{{ price }} per credit)',
      fr: '({{ currency }}{{ price }} par crédit)',
    },
    save: {
      en: 'Save {{ discount }}%',
      fr: 'Économiser {{ discount }}%',
    },
    creditsBalanceDescription: {
      en: 'Subscription credits remaining: {{ subCredits }} (renewed {{ renewalDate }}) - Extra credits: {{ permanentCredits }} (permanent)',
      fr: 'Crédits restants: {{ subCredits }} (renouvelés le {{ renewalDate }}) - Crédits supplémentaires: {{ permanentCredits }} (permanents)',
    },
    buyCreditsFailed: {
      en: 'Buy credits failed, please try again later',
      fr: "L'achat de crédits a échoué, veuillez réessayer plus tard",
    },
    requestBillingPortalUrlFailed: {
      en: 'Request billing details failed, please try again later',
      fr: 'La demande de détails de facturation a échoué, veuillez réessayer plus tard',
    },
    decreaseCredits: {
      en: 'Decrease credits',
      fr: 'Diminuer les crédits',
    },
    increaseCredits: {
      en: 'Increase credits',
      fr: 'Augmenter les crédits',
    },
    creditAddedSuccessfully: {
      en: '{{ creditAdded }} credits added to your balance!',
      fr: '{{ creditAdded }} crédits ajoutés à votre solde !',
    },
    totalCredits: {
      en: 'Your total balance is now {{ totalCredits }}',
      fr: 'Votre solde total est maintenant de {{ totalCredits }}',
    },
    altImageCreditSuccess: {
      en: 'Credit added successfully',
      fr: 'Crédits ajoutés avec succès',
    },
  },
  'app.integration-card': {
    editIntegrationName: {
      en: 'Edit integration name',
      fr: 'Modifier le nom',
    },
    disconnectIntegration: {
      en: 'Disconnect',
      fr: 'Déconnecter',
    },
    connect: {
      en: 'Connect',
      fr: 'Connecter',
    },
    connectAnother: {
      en: 'Connect another',
      fr: 'Connecter un autre',
    },
    connected: {
      en: 'Connected',
      fr: 'Connecté',
    },
    failed: {
      en: 'Failed',
      fr: 'Échoué',
    },
    pending: {
      en: 'Pending',
      fr: 'En attente',
    },
    revoked: {
      en: 'Revoked',
      fr: 'Révoqué',
    },
  },
  'app.integrations': {
    deleteIntegration: {
      en: 'Are you sure you want to disconnect?',
      fr: 'Êtes-vous sûr de vouloir déconnecter ?',
    },
    deleteIntegrationDescription: {
      en: 'This will unlink <span class="font-body-2-sb">{{ integrationUrl }}</span> from your account. You’ll need to reconnect if you want to publish or export content again.',
      fr: 'Cela désassociera <span class="font-body-2-sb">{{ integrationUrl }}</span> de votre compte. Vous devrez vous reconnecter si vous souhaitez publier ou exporter du contenu à nouveau.',
    },
    disconnect: {
      en: 'Disconnect',
      fr: 'Déconnecter',
    },
    disconnectSuccess: {
      en: 'Integration disconnected',
      fr: 'Intégration déconnectée',
    },
    editSuccess: {
      en: 'Integration updated',
      fr: 'Intégration mise à jour',
    },
    editIntegrationName: {
      en: 'Edit integration name',
      fr: 'Modifier le nom',
    },
    disconnectIntegration: {
      en: 'Disconnect',
      fr: 'Déconnecter',
    },
    shopify: {
      en: 'Shopify',
      fr: 'Shopify',
    },
    shopifyDescription: {
      en: 'Sync your content directly to Shopify, visible or hidden, to effortlessly publish generated products, pages, and descriptions to your store.',
      fr: 'Synchronisez votre contenu directement avec Shopify, visible ou masqué, pour publier facilement des produits, pages et descriptions générées dans votre boutique.',
    },
    wordpress: {
      en: 'WordPress',
      fr: 'WordPress',
    },
    wordpressDescription: {
      en: 'Publish your generated content directly to WordPress, either publicly or as drafts, with a simple connection.',
      fr: 'Publiez votre contenu généré directement avec WordPress, soit publiquement, soit en tant que brouillons, avec une simple connexion.',
    },
    noIntegrationsFound: {
      en: 'Start easily exporting your content',
      fr: 'Commencez facilement à exporter votre contenu',
    },
    noIntegrationsFoundDescription: {
      en: 'Link your accounts and send your content directly where it belongs',
      fr: 'Connectez vos comptes et envoyez votre contenu directement où il appartient',
    },
    integrations: {
      en: 'Integrations',
      fr: 'Intégrations',
    },
    connectShopify: {
      en: 'Connect with your Shopify store',
      fr: 'Connecter avec votre boutique Shopify',
    },
    connectShopifyDescription: {
      en: 'Sync your content directly to Shopify, visible or hidden',
      fr: 'Synchronisez votre contenu directement avec Shopify, visible ou masqué',
    },
    integrationName: {
      en: 'Name',
      fr: 'Nom',
    },
    integrationNamePlaceholder: {
      en: 'Enter the integration name',
      fr: "Entrer le nom de l'intégration",
    },
    integrationNameTooltip: {
      en: 'The integration name helps you easily identify your connected store. You can edit it anytime.',
      fr: "Le nom de l'intégration sera utilisé pour identifier l'intégration dans l'organisation",
    },
    myShopifyStore: {
      en: 'Shopify domain',
      fr: 'Domaine Shopify',
    },
    myShopifyStorePlaceholder: {
      en: 'your-store-name.myshopify.com',
      fr: 'your-store-name.myshopify.com',
    },
    myShopifyStoreTooltip: {
      en: 'You can find your Shopify domain in your store’s address bar, usually formatted as your-store-name.myshopify.com.',
      fr: "Vous pouvez trouver votre domaine Shopify dans la barre d'adresse de votre boutique, généralement formaté comme your-store-name.myshopify.com.",
    },
    shopifyClientId: {
      en: 'Client ID',
      fr: 'Client ID',
    },
    shopifyClientIdPlaceholder: {
      en: 'abcdef1234567890abcdef1234567890',
      fr: 'abcdef1234567890abcdef1234567890',
    },
    shopifyClientIdTooltip: {
      en: 'Found in your Shopify app settings under API credentials → Client ID.',
      fr: 'Disponible dans les paramètres de votre application Shopify sous Identifiants API → Client ID.',
    },
    shopifyClientSecret: {
      en: 'Secret',
      fr: 'Secret',
    },
    shopifyClientSecretPlaceholder: {
      en: 'shpss_xxxxxxxxxxxxxxxxxxxx',
      fr: 'shpss_xxxxxxxxxxxxxxxxxxxx',
    },
    shopifyClientSecretTooltip: {
      en: 'Found in your Shopify app settings under API credentials → Client secret.',
      fr: 'Disponible dans les paramètres de votre application Shopify sous Identifiants API → Secret client.',
    },
    oauthConnected: {
      en: 'Integration connected successfully',
      fr: 'Intégration connectée avec succès',
    },
    oauthConnectError: {
      en: 'Failed to connect integration. Please try again.',
      fr: "Échec de la connexion de l'intégration. Veuillez réessayer.",
    },
    connect: {
      en: 'Connect',
      fr: 'Connecter',
    },
    wordpressExternalName: {
      en: 'Site name',
      fr: 'Nom du site',
    },
    wordpressExternalNamePlaceholder: {
      en: 'My WordPress site',
      fr: 'Mon site WordPress',
    },
    wordpressExternalNameTooltip: {
      en: 'A name to identify this WordPress connection',
      fr: 'Un nom pour identifier cette connexion WordPress',
    },
    wordpressConnected: {
      en: 'WordPress site connected successfully',
      fr: 'Site WordPress connecté avec succès',
    },
    connectWordpress: {
      en: 'Connect with your WordPress site',
      fr: 'Connecter avec votre site WordPress',
    },
    connectWordpressDescription: {
      en: 'Connect your WordPress site to sync content',
      fr: 'Connectez votre site WordPress pour synchroniser le contenu',
    },
    wordpressIntegrationDescription: {
      en: 'Download the <0>Blym WordPress plugin</0> and paste the token into your Blym workspace.',
      fr: 'Téléchargez le <0>plugin WordPress Blym</0> et collez le jeton dans votre espace de travail Blym.',
    },
    wordpressSiteUrl: {
      en: 'Site URL',
      fr: 'URL du site',
    },
    wordpressSiteUrlPlaceholder: {
      en: 'https://mysite.com',
      fr: 'https://monsite.com',
    },
    wordpressSiteUrlTooltip: {
      en: 'The full URL of your WordPress site',
      fr: "L'URL complète de votre site WordPress",
    },
    applicationPassword: {
      en: 'Token',
      fr: 'Jeton',
    },
    applicationPasswordPlaceholder: {
      en: 'Paste your token',
      fr: 'Collez votre jeton',
    },
    applicationPasswordTooltip: {
      en: 'Copy this from WordPress under Settings → Blym.',
      fr: 'Copiez-le depuis WordPress dans Réglages → Blym.',
    },
    wordpressPluginNotReachable: {
      en: 'Plugin not reachable. Make sure the Blym plugin is installed and the token is correct.',
      fr: 'Plugin inaccessible. Assurez-vous que le plugin Blym est installé et que le jeton est correct.',
    },
    bloggle: {
      en: 'Bloggle',
      fr: 'Bloggle',
    },
    bloggleDescription: {
      en: 'Create with Blym, manage with Bloggle. Send your optimized blog posts directly into your blogging workflow.',
      fr: 'Créez avec Blym, gérez avec Bloggle. Envoyez vos articles de blog optimisés directement dans votre workflow.',
    },
    connectBloggle: {
      en: 'Connect Bloggle',
      fr: 'Connecter Bloggle',
    },
    connectBloggleDescription: {
      en: 'Sync your content directly to Bloggle, visible or hidden.',
      fr: 'Synchronisez votre contenu directement vers Bloggle, visible ou caché.',
    },
    bloggleConnected: {
      en: 'Bloggle connected successfully',
      fr: 'Bloggle connecté avec succès',
    },
    bloggleToken: {
      en: 'Token',
      fr: 'Token',
    },
    bloggleTokenPlaceholder: {
      en: 'bglt_xxxxxxxxxxxxxxxx',
      fr: 'bglt_xxxxxxxxxxxxxxxx',
    },
    bloggleTokenTooltip: {
      en: 'Generate this token in your Bloggle dashboard under Integrations',
      fr: 'Générez ce token dans votre tableau de bord Bloggle sous Integrations',
    },
  },
};
